import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    // '&:last-child:not(:nth-child(even))': {
    //   marginRight: 'auto',
    // },
  },

  imgTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '15px',
  },

  btnContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '120px',
   
    [theme.breakpoints.down(420)]: {
      width: '95px',
    },
  },

  itemBadge: {
    position: 'absolute',
    left: '7px',
    zIndex: 1,
    [theme.breakpoints.up('sm')]: {
      left: '45px',
      transform: 'scale(0.8)',
    },
  },
});
